// Genera un código de barras interno EAN-13 válido con prefijo 200 (uso interno,
// no colisiona con GTIN reales). Incluye el dígito verificador.
export function genInternalBarcode(): string {
  let base = '200';
  for (let i = 0; i < 9; i++) base += Math.floor(Math.random() * 10);
  const digits = base.split('').map(Number);
  let sum = 0;
  digits.forEach((d, i) => {
    sum += d * (i % 2 === 0 ? 1 : 3);
  });
  const check = (10 - (sum % 10)) % 10;
  return base + String(check);
}
